export const mergeSalesforcePendingUserPages = (currentCache, newPage, { arg } = {}) => {
	// First page (initial load or refetch after sync/approve) replaces the cache.
	// Later pages append for infinite scroll.
	if ((arg?.skip ?? 0) === 0) {
		return {
			items: [...(newPage?.items ?? [])],
			totalCount: newPage?.totalCount ?? 0,
		};
	}

	const existing = currentCache?.items ?? [];
	const incoming = newPage?.items ?? [];
	const existingIds = new Set(existing.map((item) => item.id));
	const uniqueIncoming = incoming.filter((item) => !existingIds.has(item.id));
	return {
		items: [...existing, ...uniqueIncoming],
		totalCount: newPage?.totalCount ?? currentCache?.totalCount ?? 0,
	};
};
